(() => {
  const mount = () => {
    const data = document.querySelector('#cont-rl-w [data-rvw2-list]');
    if (!data) return;
    let list;
    try { list = JSON.parse(data.textContent); } catch { return; }
    if (!Array.isArray(list)) return;
    document.querySelectorAll('[data-kinich-reviews]').forEach(root => {
      if (root.dataset.ready) return;
      const reviews = list.filter(r => String(r.product?.productId) === root.dataset.productId && typeof r.comment === 'string' && r.comment.trim() && Number(r.stars) >= 1 && Number(r.stars) <= 5).sort((a, b) => Number(b.stars) - Number(a.stars));
      if (!reviews.length) return;
      root.dataset.ready = 'true';
      root.setAttribute('role', 'region');
      root.setAttribute('aria-label', 'Reseñas de este producto');
      const content = document.createElement('div');
      content.className = 'kinich-review-carousel__content';
      content.setAttribute('aria-live', 'polite');
      const head = document.createElement('div');
      head.className = 'kinich-review-carousel__head';
      const stars = document.createElement('span');
      stars.className = 'kinich-review-carousel__stars';
      const name = document.createElement('strong');
      head.append(stars, name);
      const quote = document.createElement('p');
      content.append(head, quote);
      const footer = document.createElement('div');
      footer.className = 'kinich-review-carousel__footer';
      const link = document.createElement('a');
      link.href = '#cont-rl-w';
      link.textContent = 'Ver todas las reseñas';
      const controls = document.createElement('div');
      controls.className = 'kinich-review-carousel__controls';
      const count = document.createElement('span');
      let index = 0;
      const show = () => {
        const review = reviews[index];
        const rating = Number(review.stars);
        stars.textContent = '★'.repeat(rating) + '☆'.repeat(5 - rating);
        stars.setAttribute('aria-label', rating + ' de 5 estrellas');
        name.textContent = review.customer?.firstName || 'Cliente Kinich';
        quote.textContent = review.comment.trim();
        count.textContent = (index + 1) + ' / ' + reviews.length;
      };
      const button = (label, symbol, delta) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', label);
        b.textContent = symbol;
        b.addEventListener('click', () => { index = (index + delta + reviews.length) % reviews.length; show(); });
        return b;
      };
      if (reviews.length > 1) controls.append(button('Reseña anterior', '‹', -1), count, button('Siguiente reseña', '›', 1));
      footer.append(link, controls);
      root.append(content, footer);
      show();
      root.hidden = false;
    });
  };
  mount();
  const observer = new MutationObserver(mount);
  observer.observe(document.body, {childList: true, subtree: true});
  window.addEventListener('pagehide', () => observer.disconnect(), {once: true});
})();
